import { motion } from 'framer-motion';

const EASE = [0.22, 1, 0.36, 1];

export const FadeIn = ({ children, delay = 0, y = 28, className = '', ...rest }) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-60px' }}
        transition={{ duration: 0.9, delay, ease: EASE }}
        className={className}
        {...rest}
    >
        {children}
    </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = '' }) => (
    <span className={`block overflow-hidden pb-1 ${className}`}>
        <motion.span
            className="block"
            initial={{ y: '115%' }}
            animate={{ y: 0 }}
            transition={{ duration: 1.1, delay, ease: EASE }}
        >
            {children}
        </motion.span>
    </span>
);

export const ChapterMark = ({ index, label }) => (
    <FadeIn y={14} className="mb-6 flex items-center justify-center gap-4">
        <span className="h-px w-10 bg-champagne/60" aria-hidden="true" />
        <span className="eyebrow" data-testid={`chapter-${index}`}>
            Chapitre {index} {label ? `— ${label}` : ''}
        </span>
        <span className="h-px w-10 bg-champagne/60" aria-hidden="true" />
    </FadeIn>
);
